import BaseQuestionModel from '../BaseQuestionModel'
import { getCheckNumber } from '../MaxdiffBW/Component'
import { ReorderResponse } from '../Reorder/types'
import { IQuestionModelConstructor, QuestionType } from '../types'
import {
  MaxdiffQuestionModelTypes,
  IMaxdiffQuestionModelState,
  IMaxdiffResponseValidation,
  MaxdiffSubmitResponse,
  MaxdiffCheckResponse
} from './types'

const EMPTY_RESPONSE: ReorderResponse = []

const MaxdiffQuestionModel: IQuestionModelConstructor<MaxdiffQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<MaxdiffQuestionModelTypes, IMaxdiffQuestionModelState>({
    questionType: QuestionType.MAXDIFF,
    questionSchema: questionSchema,
    action,
    submitResponse,
    checkResponse,
    initState,
    validateResponse
  })
  model.navigationFrame = [1, model.schema.answers_mask.length]
  return model
}

function submitResponse({ response }: IMaxdiffQuestionModelState): MaxdiffSubmitResponse {
  return response.frames.map(frameResponse =>
    frameResponse.map(answer => {
      return {
        id: answer
      }
    })
  )
}

function checkResponse({ response }: IMaxdiffQuestionModelState): MaxdiffCheckResponse {
  return response.checkShown
    ? {
        response: response.checkResponse.map(answer => {
          return { id: answer }
        }),
        position: response.checkNumber
      }
    : { response: [] }
}

function initState(state: IMaxdiffQuestionModelState): IMaxdiffQuestionModelState {
  state.response = {
    frames: state.questionSchema.answers_mask.map(() => EMPTY_RESPONSE),
    checkShown: false,
    checkResponse: [],
    checkNumber: getCheckNumber(state.questionSchema)
  }
  state.response.checkResponse = []
  return state
}

function validateResponse({ questionSchema, response, frame }: IMaxdiffQuestionModelState): IMaxdiffResponseValidation {
  if (questionSchema.answers.length <= 1)
    return {
      valid: true
    }
  if (questionSchema.check && !response.checkShown && frame === response.checkNumber) {
    return {
      valid: response.checkResponse.length > 0
    }
  }

  return {
    valid: response.frames[frame as number]?.length > 0
  }
}

export default MaxdiffQuestionModel
